/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import PartnerAgreement from "./PartnerAgreement.container";

export default PartnerAgreement;
